import { render, staticRenderFns } from "./customerSelect.vue?vue&type=template&id=126226d7"
import script from "./customerSelect.vue?vue&type=script&lang=js"
export * from "./customerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports